import { Badge, BeekLogo, Icon, Link, Typography } from 'beek-design-system';
import { useTranslations } from 'next-intl';
import styled from 'styled-components';

import Const from 'src/config/Const';

type FooterProps = {
  changeLanguage: (value: string) => void;
  getLanguage: () => string | undefined;
};

const LinksDesktop = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin-top: 5rem;
  max-width: 57.25rem;
  width: 100%;
`;

const FlexColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const FlexContainer = styled.div`
  display: flex;
`;

const StyledSelect = styled.select`
  border: none;
  color: var(--gray-70);
  font-family: var(--primary-font);
  font-size: 0.75rem;
  font-weight: normal;
  line-height: 1rem;
  background-color: transparent;
`;

const FooterDesktop = (props: FooterProps): JSX.Element => {
  const t = useTranslations('articles');
  const { getLanguage, changeLanguage } = { ...props };

  return (
    <>
      <FlexContainer>
        <FlexContainer>
          <BeekLogo marginRight="4.406rem" variant="normal" />
        </FlexContainer>
        <FlexColumnContainer style={{ marginRight: '3.906rem' }}>
          <Typography
            type="buttons"
            colorVariant="gray70"
            marginBottom="1.25rem"
          >
            {`${t('footer.discovery')}`}
          </Typography>
          <Link
            href="/html_sitemap/audiolibros_a.html"
            textDecoration="none"
            typographyType="body2"
            colorVariant="gray70"
            marginBottom="0.75rem"
          >
            {`${t('footer.audiobooks')}`}
          </Link>
          <Link
            href="/listas"
            textDecoration="none"
            typographyType="body2"
            colorVariant="gray70"
          >
            {`${t('footer.articles')}`}
          </Link>
        </FlexColumnContainer>
        <FlexColumnContainer style={{ marginRight: '2.25rem' }}>
          <Typography
            type="buttons"
            colorVariant="gray70"
            marginBottom="1.25rem"
          >
            {`${t('footer.company')}`}
          </Typography>
          <Link
            href="https://airtable.com/shrTI11sflvyIlfua"
            textDecoration="none"
            typographyType="body2"
            colorVariant="gray70"
            marginBottom="0.75rem"
            external
          >
            {t('footer.becomeCreator')}
          </Link>
          <Link
            href="https://beek.breezy.hr/"
            textDecoration="none"
            typographyType="body2"
            colorVariant="gray70"
          >
            {t('footer.work')}
          </Link>
        </FlexColumnContainer>
        <FlexColumnContainer style={{ marginRight: '9.625rem' }}>
          <Typography
            type="buttons"
            colorVariant="gray70"
            marginBottom="1.25rem"
          >
            {`${t('footer.support')}`}
          </Typography>
          <Link
            href="https://www.notion.so/Preguntas-frecuentes-43a0f97ad89d46acb055ff37b961c8ac"
            textDecoration="none"
            typographyType="body2"
            colorVariant="gray70"
            marginBottom="0.75rem"
          >
            {`${t('footer.frequentQuestions')}`}
          </Link>
          <Link
            href={Const.supportUrl}
            textDecoration="none"
            typographyType="body2"
            colorVariant="gray70"
          >
            {`${t('footer.help')}`}
          </Link>
        </FlexColumnContainer>
        <FlexColumnContainer>
          <Typography
            type="buttons"
            colorVariant="gray70"
            marginBottom="1.25rem"
          >
            {`${t('footer.download')}`}
          </Typography>
          <Badge variant="applestore" marginBottom="1rem" />
          <Badge variant="playstore" />
        </FlexColumnContainer>
      </FlexContainer>
      <LinksDesktop>
        <FlexContainer>
          <Typography
            type="caption"
            colorVariant="gray50"
            marginRight="2.75rem"
          >
            {`${t('footer.copyright', {
              currentYear: new Date().getFullYear(),
            })}`}
          </Typography>
          <Link
            href="/aviso_privacidad.pdf"
            external
            textDecoration="none"
            typographyType="caption"
            colorVariant="gray70"
            locale={false}
          >
            {`${t('footer.privacy')}`}
          </Link>
          <Typography
            type="caption"
            colorVariant="gray50"
            marginRight="1rem"
            marginLeft="1rem"
          >
            |
          </Typography>
          <Link
            href="/terms.pdf"
            external
            textDecoration="none"
            typographyType="caption"
            colorVariant="gray70"
            locale={false}
          >
            {`${t('footer.terms')}`}
          </Link>
          <Typography
            type="caption"
            colorVariant="gray50"
            marginRight="1rem"
            marginLeft="1rem"
          >
            |
          </Typography>
          <Link
            href="/sitemap.xml"
            external
            textDecoration="none"
            typographyType="caption"
            colorVariant="gray70"
            locale={false}
          >
            {`${t('footer.map')}`}
          </Link>
        </FlexContainer>
        <FlexContainer>
          <Icon
            name="world"
            colorVariant="gray50"
            marginRight="0.437rem"
            marginTop="0.2rem"
          />
          <StyledSelect
            onChange={(e): string | void => changeLanguage(e.target.value)}
            value={getLanguage()}
            data-testid="select-language"
          >
            <option value="es">{`${t('footer.languageEs')}`}</option>
            <option value="en">{`${t('footer.languageEn')}`}</option>
          </StyledSelect>
        </FlexContainer>
      </LinksDesktop>
    </>
  );
};

export default FooterDesktop;
